import { sidebar as sidebarConfig, showPaths } from './context-chat.config';

import type {
  ContextChatSession,
  ContextChatSurface,
} from './context-chat.types';

export function surfaceForSession(
  session: ContextChatSession | undefined
): ContextChatSurface {
  if (session?.context.type === 'action-card') return 'feed';
  return session?.context.type === 'general' ? 'meetings-list' : 'meeting';
}

export function shouldShowOnPath(pathname: string) {
  return showPaths.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

export function computeDockMetrics({
  viewportWidth,
  leftSidebar,
  sidebarWidth,
}: {
  viewportWidth: number;
  leftSidebar: number;
  sidebarWidth: number;
}) {
  const availableDockWidth =
    viewportWidth > 0
      ? viewportWidth -
        leftSidebar -
        sidebarConfig.dockedGutterPx -
        sidebarConfig.dockedContentMinPx
      : sidebarConfig.maxWidth;
  const canDock = availableDockWidth >= sidebarConfig.minWidth;
  const maxWidth = Math.min(sidebarConfig.maxWidth, availableDockWidth);
  const width = Math.min(sidebarWidth, maxWidth);
  return { availableDockWidth, canDock, maxWidth, width };
}
